import { render } from "./MerchView.vue?vue&type=template&id=2487a58c&scoped=true"
import script from "./MerchView.vue?vue&type=script&lang=js"
export * from "./MerchView.vue?vue&type=script&lang=js"

import "./MerchView.vue?vue&type=style&index=0&id=2487a58c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2487a58c"]])

export default __exports__